import { createSlice } from '@reduxjs/toolkit';

const chatSlice = createSlice({
  name: 'chatbot',
  initialState: {
    chatMessage: '',
  },
  reducers: {
    setChatMessage: (state, action) => {
      state.chatMessage = action.payload;
    },
  },
});

export const { setChatMessage } = chatSlice.actions;

/**
 * Queued messages already taken by a panel, so one press cannot become two
 * questions.
 *
 * Module-level rather than a ref in either panel, because **two panels read
 * this slice** — `loan-management/chat-model` and `officer/chat-model` — and
 * each processes the queue in its own effect. A per-component guard leaves the
 * duplicate in place whenever both are mounted, since neither knows the other
 * ran. Importing one set is what makes the claim shared.
 *
 * Only messages carrying a `requestId` are claimable. A queued message without
 * one behaves exactly as it always has.
 *
 * @returns {boolean} true if the caller may send it — false if somebody already did.
 */
const claimed = new Set();

export const claimQueuedRequest = (requestId) => {
  if (!requestId) return true;
  if (claimed.has(requestId)) return false;
  claimed.add(requestId);
  return true;
};

export const chatbotData = (state) => state.chatMessage;
export default chatSlice.reducer;
